export const STORES_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const PAID_PLANS_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const EXPERIMENT_USE_BASS_API = 'specs.subscriptionsTpa.UseBassAPI';
